module.exports = __webpack_public_path__ + "img/golang.c1807500.png";